import { render, staticRenderFns } from "./SamIcon.vue?vue&type=template&id=57fb8eb2&scoped=true&"
import script from "./SamIcon.vue?vue&type=script&lang=js&"
export * from "./SamIcon.vue?vue&type=script&lang=js&"
import style0 from "./SamIcon.vue?vue&type=style&index=0&id=57fb8eb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fb8eb2",
  null
  
)

export default component.exports